/**
 * 客流计数相关接口
 */
import { get, post } from '@/common/request/index';

/**
 * 关联机会点 https://yapi.lanhanba.com/project/329/interface/api/73604
 */
export function relateToChancePoint(params: Record<string, any>) {
  return post('/checkSpot/relateChancePoints', params, true);
}

/**
 * 获取关联的机会点 https://yapi.lanhanba.com/project/329/interface/api/73597
 */
export function getRelativeChancePoint(params: Record<string, any>) {
  return get('/checkSpot/queryRelatedChancePoints', params, true);
}

/**
 * 导出任务下客流数据 https://yapi.lanhanba.com/project/329/interface/api/74150
 */
export function exportFlowData(params: any) {
  return post('/checkSpot/device/exportFlow', params, true);
}

/**
 * 点位详情
 * @param id 点位ID
 * https://yapi.lanhanba.com/project/329/interface/api/73737
 */
export function taskSpotDetail(id:string|number) {
  return get('/checkSpot/device/taskSpotDetail', { id }, {
    needCancel: true
  });
}

/**
 * 点位详情-演示数据
 * @param id 点位ID
 */
export function taskSpotDetailDemo(id:string|number) {
  return get('/checkSpot/device/taskSpotDetail/demo', { id }, {
    needCancel: true
  });
}


/**
 * 任务分析详情
 * @param id 任务ID
 * https://yapi.lanhanba.com/project/329/interface/api/70776
 */
export function deviceTaskAnalysisDetail(id:string|number) {
  return get('/checkSpot/device/taskAnalysisDetail', { id }, {
    needCancel: true
  });
}

/**
 * 任务分析详情-演示数据
 * @param id 任务ID
 */
export function deviceTaskAnalysisDetailDemo(id:string|number) {
  return get('/checkSpot/device/taskAnalysisDetail/demo', { id }, {
    needCancel: true
  });
}


/**
 * 点位下已分析客流数据  https://yapi.lanhanba.com/project/329/interface/api/75403
 * @param id 点位ID
 */
export function taskSpotLines(params: any) {
  return get('/checkSpot/device/taskSpotChart', { ...params }, {
    needCancel: true
  });
}



